<template>
	<li class="item" v-bind:class=" { 'already-read' : alreadyRead} ">
		<div class="apply-btn" @click = "apply">{{applyhtml}}</div>

		<a :href= "item.url" class = "item-a" @click = "clicklog">
            <!-- 本期先不做企业logo    -->
        <!-- <img src="../../assets/logo.png" alt="企业logo" class = "item-logo">       -->
        <dl class="item-main">
			<dt class="item-title">{{item.title}}
				<span class="mark">{{item.dateShow}}</span>
			</dt>
			<dd class="item-desc">
				<span class="salary">{{item.salary}}{{item.unit}}</span>
			</dd>
			<dd class="welfares">
				<!-- <span class="license">{{item.liyou}}</span> -->
				<span v-for="(welfare,index) in item.welfarelist" :key ="welfare" v-if="0<=index && index<3 ">{{welfare}}</span>
			</dd>
		</dl>
		</a>
		<div class="item-bottom">
            <i :class="classObject"></i>
			<span>{{item.enterprisename}}</span>
			<span class="distance">{{item.local}}</span>
		</div>
	</li>
</template>
<script>
import {mapState} from 'vuex';
import data from './../../api/index';
export default {
	props: ['item', 'index', 'partid'],
	data() {
		return {
			alreadyRead: false, //已申请或者已点击职位职位置灰
			applyhtml: '申请' //申请文案点击后变为已申请
		};
	},
	computed: {
		//根据数据返回判断是左下角企业身份标志
		classObject: function() {
			let cate = this.item.isdaizhao === '1' ? 'daizhao' : this.item.ismingqi === '1' ? 'fame-com' : this.item.isrenli === '1' ? 'hr' : this.item.isvip === '1' ? 'vip' : '';
			return 'com-name ' + cate;
		},
		...mapState([
			'userid', //用户id
			'currentPart' //当前展示模块
		])
	},
	methods: {
		//点击职位进详情的时候进行埋点
		clicklog: function() {
			this.alreadyRead = true;
			window.clickLog && window.clickLog('from=zpbrainreclisttjdj&tjfrom=' + this.item.tjfrom + '___&infoid=' + this.item.infoid + '&platform=m_aggregationtest' + this.partid);
		},
		//点击申请进行投递
		apply: function() {
			window.clickLog && window.clickLog('from=tjapplyclick&tjfrom=' + this.item.tjfrom + '___&infoid=' + this.item.infoid + '&platform=m_aggregationapply' + this.partid);
			this.alreadyRead = true;
			this.applyhtml = '已申请';
			// window.delivery_new(this.item.infoid, this.item.mcityname, this.item.areaid, this.item.deliverySource, this.item.tjfrom, 0, false, (result) => {});
			window.delivery_new({
				infoId: this.item.infoid,
				deliverySource: 42,
				tjFrom: this.item.tjfrom,
				finalCp: this.item.finalCp,
				displayGuideBox: false
			});
			//右侧气泡是否展示
			if (this.userid) {
				this.$store.dispatch('getApplyNum', this.userid);
			}
			// 优选数据上报
			if (this.item.chargeurl) {
				data.dataReport({url: this.item.chargeurl + '&nojump=1'})
			}
		}
	}
};
</script>
<style lang = "scss">
@import "../../assets/style/public.scss";
.before-style{
    font-family: "iconfont" !important;
    font-style: normal;
    font-weight: normal;
    display: inline-block;
    font-size: px2rem(64px);
    position: absolute;
    top: 48%;
    left:px2rem(-6px);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.item {
    position: relative;
    margin-bottom: px2rem(20px);
    background: $white;
    padding:px2rem(30px)  px2rem(30px) 0 px2rem(30px);
    -webkit-tap-hightlight-color:rgba(0,0,0,0);
    &:last-child{
        margin-bottom: 0;
    };
    .apply-btn {
        position: absolute;
        top: px2rem(110px);
        right: px2rem(30px);
        width: px2rem(96px);
        height: px2rem(54px);
        line-height: px2rem(54px);
        background-color: #f86747;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        font-size: px2rem(26px);
    }
    .item-a {
        display: block;
        width:85%;
        -webkit-tap-hightlight-color:rgba(0,0,0,0);
    }
    .mark {
        position: absolute;
        right: px2rem(30px);
        top:px2rem(40px);
        font-size: px2rem(22px);
        color:#aaa;
    }
    .item-logo{
        display:inline-block;
        width:px2rem(136px);
        height:px2rem(136px);
        margin-right:px2rem(20px);
    }
    .item-main {
        display:inline-block;
        vertical-align:top;
        padding-bottom:px2rem(24px);
        .item-title {
            font-size: px2rem(30px);
            color:#000;
        }
        .item-desc {
            line-height:px2rem(60px);
            .salary {
                color: #ff552e;
                font-size: $font-size;
            }
        }
        .welfares {
            font-size:px2rem(22px);
            span {
                display: inline-block;
                border: 1px solid #15b4e9;
                border-radius: 2px;
                color: #15b4e9;
                padding: 0px 2px;
                margin-right: px2rem(10px);
            }
        }
    }
    .item-bottom {
        line-height: px2rem(80px);
        color: #808080;
        font-size: px2rem(24px);
        border-top: 1px solid #f3f3f3;
        .com-name{
            vertical-align: middle;
            position: relative;
        }
        .hr{
            display: inline-block;
            width: px2rem(60px);
            height: px2rem(60px);
            &:before{
                @extend .before-style;
                content: "\e600";
                color: #ff7171;
            }
        }

        .fame-com{
            display: inline-block;
            width: px2rem(60px);
            height: px2rem(60px);
            &:before{
                @extend .before-style;
                content: "\e601";
                color: #ffac00;
            }
        }
        .vip{
            display: inline-block;
            width: px2rem(60px);
            height: px2rem(60px);
            &:before{
                @extend .before-style;
                content: "\e602";
                color: #15b4e9;
            }
        }
        .daizhao{
            display: inline-block;
            width: px2rem(60px);
            height: px2rem(60px);
            &:before{
                @extend .before-style;
                content: "\e603";
                color: #15b4e9;
            }
        }
        .distance {
            float: right;
            font-size: px2rem(22px);
        }
    }

}

.already-read .item-title, .already-read .salary, .already-read .license, .already-read .welfares span, .already-read .cate-name, .already-read .hr:before, .already-read .fame-com:before, .already-read .vip:before, .already-read .daizhao:before {
    color: #848484 !important;
}
.already-read .apply-btn {
    background-color: #848484 !important;
}
.already-read .welfares span {
    border-color: #848484 !important;
}

</style>



// WEBPACK FOOTER //
// item.vue?545356ee